import React from "react"
import PropTypes from "prop-types"
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material"
import i18n from "i18n"

const ModalWaiting = ({
  open,
  setOpen: _setOpen,
  setOpenAnt: _setOpenAnt,
  project: _project,
  loading,
  imInBudget,
}) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={() => {}}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown
        slotProps={{
          backdrop: { "aria-busy": true },
        }}
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogContent
          sx={{
            py: 4,
            px: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: 3,
          }}
        >
          <Typography variant="h6" component="p" sx={{ fontWeight: 500 }}>
            {i18n.t("modalWaiting.preparingBudget")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 40,
            }}
          >
            <CircularProgress color="primary" />
          </Box>
        </DialogContent>
      </Dialog>
      {!loading && imInBudget ? location.reload() : null}
    </>
  )
}

ModalWaiting.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  project: PropTypes.object,
  imInBudget: PropTypes.bool,
  loading: PropTypes.bool,
  setOpenAnt: PropTypes.func.isRequired,
}
export default ModalWaiting
